module.exports = __webpack_public_path__ + "img/icon_pdf.12cbf881.jpg";